import { Email, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { ProgressMeter } from "@msuite/ui/progress-meter";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { guardNumber, sumUpByKey } from "@msuite/utils/numbers";
import { guardString } from "@msuite/utils/strings";
import type { AggregatedUserOverviewMeasurement } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<AggregatedUserOverviewMeasurement>();

export const columns = [
	columnHelper.accessor("member.user.firstName", {
		header: localized("profile.first_name"),
		id: "firstName",
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("member.user.lastName", {
		header: localized("profile.last_name"),
		id: "lastName",
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("member.user.email", {
		header: localized("personnel.fields.email"),
		id: "id",
		cell: (cell) => <Email>{guardString(cell.getValue())}</Email>,
	}),
	columnHelper.accessor("member.user.phone", {
		header: localized("personnel.fields.phone"),
		id: "phone",
		cell: (cell) => <Phone>{guardString(cell.getValue())}</Phone>,
	}),
	columnHelper.accessor((row) => row.measurements.length, {
		id: "measurementsCount",
		header: localized("projects.projects"),
		cell: (cell) => guardNumber(cell.getValue()),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor((row) => sumUpByKey(row.measurements, "taCount"), {
		id: "ticketAssignmentCount",
		header: localized("measurements.ticket_assignments_total"),
		cell: (cell) => guardNumber(cell.getValue()),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor((row) => sumUpByKey(row.measurements, "tamsCount"), {
		id: "tamsCount",
		header: localized("measurements.ticket_assignment_measurement_statements_total"),
		cell: (cell) => guardNumber(cell.getValue()),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor(
		(row) => {
			const taCount = sumUpByKey(row.measurements, "taCount");
			const tamsOpenCount = sumUpByKey(row.measurements, "tamsOpenCount");
			return (tamsOpenCount / taCount) * 100;
		},
		{
			id: "progress",
			size: 250,
			enableResizing: false,
			header: localized("general.progress"),
			cell: (cell) => {
				return (
					<div className="flex-center h-full pr-4">
						<ProgressMeter value={cell.getValue()} />
					</div>
				);
			},
		},
	),
	createRowActions(RowActions),
];
